<nz-modal [(nzVisible)]="isVisible" (nzOnCancel)="close()" [nzWidth]="modalWidth">
  <ng-container *nzModalContent>
    <div id="dowebok" #dowebok class="list">
      <img class="image" [src]="showImgUrl" style="width: 100%" alt="" (click)="close()" />
    </div>
  </ng-container>
  <div *nzModalFooter></div>
</nz-modal>
